import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["countryCode", "className"];
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
const unavailableCountryCodes = ['uk', 'an', 'ap'];
function getFlagEmoji(countryCode) {
  if (unavailableCountryCodes.includes(countryCode)) {
    return '';
  }
  const UTF_16_A = 65;
  const UTF_16_REGION_A = 127462;
  const REGION_START = UTF_16_REGION_A - UTF_16_A;
  const codePoints = countryCode.toUpperCase().split('').map(char => REGION_START + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
}
function CountryFlag(_ref) {
  let {
      countryCode,
      className
    } = _ref,
    passThroughProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx("span", Object.assign({}, passThroughProps, {
      className: classNames('country-flag', className, countryCode.toLowerCase()),
      children: getFlagEmoji(countryCode)
    }))
  );
}
export default CountryFlag;